import { gql } from "graphql-request";

/** Inscripción pública EIDU: reutiliza crearDocente (sin login). */
export const inscribirEidu = gql`
  mutation crearDocente(
    $tipo: Int
    $identificacion: String
    $nombre: String
    $correoInstitucional: String
    $telefono: String
    $unidad: String
    $carrera: String
    $periodoMatricula: Int
    $grupo: Int
    $universidad: String
    $pais: String
    $tieneDiscapacidad: Boolean
    $tipoDiscapacidad: String
    $requiereApoyo: Boolean
    $detalleApoyo: String
  ) {
    crearDocente(
      tipo: $tipo
      identificacion: $identificacion
      nombre: $nombre
      correoInstitucional: $correoInstitucional
      telefono: $telefono
      unidad: $unidad
      carrera: $carrera
      periodoMatricula: $periodoMatricula
      grupo: $grupo
      sede: false
      universidad: $universidad
      pais: $pais
      tieneDiscapacidad: $tieneDiscapacidad
      tipoDiscapacidad: $tipoDiscapacidad
      requiereApoyo: $requiereApoyo
      detalleApoyo: $detalleApoyo
    ) {
      docente {
        id
        identificacion
        nombre
      }
      matriculado {
        id
      }
      success
    }
  }
`;

export const buscarInscritoEidu = gql`
  query inscritoEidu($identificacion: String!) {
    inscritoEidu(identificacion: $identificacion) {
      id
      nombre
      identificacion
      pais
      correoInstitucional
      telefono
      unidad
      carrera
      universidad
      tieneDiscapacidad
      tipoDiscapacidad
      requiereApoyo
      detalleApoyo
      matriculadoSet {
        id
        grupo {
          id
          nombre
          cupoDisponible
        }
      }
    }
  }
`;

export const asignarTallerEidu = gql`
  mutation asignarTallerEidu($idDocente: Int!, $grupo: Int) {
    asignarTallerEidu(idDocente: $idDocente, grupo: $grupo) {
      docente {
        id
        nombre
      }
      matriculado {
        id
        grupo {
          id
          nombre
        }
      }
      success
    }
  }
`;
